// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + "goals" + "." + "8eec797d21201f69f09a" + ".css";
};